<finder-anchor [href]="link" class="active-link">
    <div class="learn-more">
        <div class="image-container">
            <finder-picture *ngIf="picture"
                class="fit"
                [picture]="picture">
            </finder-picture>
        </div>
        <div class="text-container">
            <span [innerHtml]="title | safeHtml"></span>&nbsp;
            <span class="link">{{linkText}}</span>
        </div>
    </div>
</finder-anchor>
